import { useSpecialHandlingIndMappingVM } from "presentation/hook/SpecialHandlingIndMapping/useSpecialHandlingIndMappingVM";
import { useSpecialHandlingIndMappingTracked } from "presentation/store/SpecialHandlingIndMapping/SpecialHandlingIndMappingProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import SpecialHandlingIndMappingEditPanel from "./RightPanel/SpecialHandlingIndMappingEditPanel";
import SpecialHandlingIndMappingTablePanel from "./Table/SpecialHandlingIndMappingTablePanel";


const SpecialHandlingIndMappingMaintenance: React.FC = () => {
    const [specialHandlingIndMappingState] = useSpecialHandlingIndMappingTracked();
    const [isLoading, setIsLoading] = useState(true);
    const specialHandlingIndMappingVM = useSpecialHandlingIndMappingVM();
    const { isShowEditPanel } = specialHandlingIndMappingState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    specialHandlingIndMappingVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            specialHandlingIndMappingVM.searchAllspecialHandlingIndMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [specialHandlingIndMappingVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>

            {!(isShowEditPanel) && <>
                <SpecialHandlingIndMappingTablePanel /></>}
            {(isShowEditPanel) && <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={"100%"}
                rightSectionWidth={"0%"}
                leftChildren={<SpecialHandlingIndMappingEditPanel />}
            />}
        </div>
    </>
}

export default memo(SpecialHandlingIndMappingMaintenance);